import React from 'react';
import PropTypes from 'prop-types';

import '../styles/index.scss';

/**
 * A container for a user information message displayed to the user. It mainly provides reusable markup and styling for the
 * message, but don't care about what the message is. User can provide any children to the component which will be added
 * as children to this component as the message.
 */
const UserInfoMessage = ({children}) => <div className="UserInfoMessage">{children}</div>;

UserInfoMessage.propTypes = {
  children: PropTypes.node,
};

export default UserInfoMessage;
